import { useAppSelector } from 'flow/hooks/useRedux';
import { TypedMap } from 'flow/types/TypedMap';
import { ContactFull } from 'flow/types/Contact';
import { TelephoneNumber } from 'flow/types/TelephoneNumber';
import { selectUserCountryCode } from 'flow/selectors/ExtensionSelectors';
import { prettyFormatE164Number } from 'flow/utils/call-utils';
import useAppContext from 'flow/hooks/useAppContext';
import NumberWrapper from 'flow/components/ui-components/NumberWrapper';
import ContactTypeIcon from 'flow/components/contact/ContactTypeIcon';

interface Props {
    contact?: TypedMap<ContactFull>;
    contactFullName?: string;
    number?: TypedMap<TelephoneNumber>;
    hideIcon?: boolean;
}

const ContactTitle = ({
    contact,
    contactFullName,
    number,
    hideIcon,
}: Props) => {
    const { i18next } = useAppContext();
    const userCountryCode = useAppSelector(selectUserCountryCode);

    const icon = hideIcon ? null : (
        <ContactTypeIcon
            contact={contact}
            className="size-[18px]! shrink-0 bg-transparent! p-0!"
        />
    );

    if (contactFullName) {
        return icon ? (
            <span className="inline-flex min-w-0 items-center gap-1">
                <span className="min-w-0 truncate">{contactFullName}</span>
                {icon}
            </span>
        ) : (
            <>{contactFullName}</>
        );
    }

    const companyName = contact?.get('companyName');
    if (companyName) {
        return icon ? (
            <span className="inline-flex min-w-0 items-center gap-1">
                <span className="min-w-0 truncate">{companyName}</span>
                {icon}
            </span>
        ) : (
            <>{companyName}</>
        );
    }

    if (number?.get('type') === 'technical_number') {
        return null;
    }

    const phoneNumber = number?.get('number');

    if (phoneNumber === 'unknown' || phoneNumber === 'anonymous') {
        return i18next.t('call.hidden_number');
    }

    return (
        <NumberWrapper>
            {prettyFormatE164Number(phoneNumber, userCountryCode)}
        </NumberWrapper>
    );
};

export default ContactTitle;
